import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { INotification } from '@models/notification/notification';
import { IProduct } from '@models/product';
import { NotificationService } from '@services/global/notification.service';
import { ProductService } from '@services/global/product.service';
import { MenuService } from '@services/menu.service';
import { clone } from '@shared/arrays';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-notification-button',
  templateUrl: './notification-button.component.html',
  styleUrls: ['./notification-button.component.scss']
})
export class NotificationButtonComponent implements OnInit, OnDestroy, AfterViewInit {
  get _notifications() {
    return this.notificationService.notifications;
  }
  public notificationListVisible = false;
  public products: IProduct[] = [];
  public isLoading = false;
  private mouseTracker;

  constructor(
    private readonly notificationService: NotificationService,
    private readonly productService: ProductService,
    private readonly menuService: MenuService
  ) {}

  get notificationsForPopup() {
    const notificationsToDisplay: INotification[] = [];
    if (this._notifications.length > 0) {
      // @ts-ignore
      const sortedByTimeNotifications = clone(this.notifications.sort((a, b) => a.DateTimeCreated - b.DateTimeCreated));

      notificationsToDisplay.push(sortedByTimeNotifications.pop());
      let notification: INotification;

      while (sortedByTimeNotifications.length > 0) {
        notification = sortedByTimeNotifications.pop();
        if (
          (notification && notification.ProductId !== notificationsToDisplay[notificationsToDisplay.length - 1].ProductId) ||
          notification.CalibrationType !== notificationsToDisplay[notificationsToDisplay.length - 1].CalibrationType
        ) {
          notificationsToDisplay.push(notification);
          return notificationsToDisplay;
        }
      }
    }

    return notificationsToDisplay;
  }

  ngOnInit() {
    this.loadData();
  }

  ngAfterViewInit() {
    this.mouseTracker = fromEvent(document, 'click').subscribe((e: MouseEvent) => {
      if (!(e.target as HTMLInputElement).closest('#notification-button') && this.notificationListVisible) {
        this.notificationListVisible = false;
      }
    });
  }

  ngOnDestroy() {
    this.mouseTracker.unsubscribe();
  }

  private async loadData() {
    this.isLoading = true;
    this.products = await this.productService.getProducts().toPromise();
    this.isLoading = false;
  }

  public openNotificationDialog() {
    this.openNotificationPreview();
    this.notificationService.openNotificationWindow();
  }

  public openNotificationPreview() {
    this.notificationListVisible = !this.notificationListVisible;
  }

  public popupErrorMessage(title: string): string {
    switch (title) {
      case 'DECAY':
        return 'Invalid decay factors exist for ';
      case 'STABLE_BALANCE':
        return 'Negative non-stable balances exist for ';
      case 'PRODUCT_DETAIL':
        return 'Negative stable balance vintages exist for ';
      case 'RECALCULATION':
        return 'Recalculation error for ';
    }
  }

  public mapProductIdToName(productId: number): string {
    return this.products.find(x => x.ProductId === productId).ProductName;
  }

  get notifications() {
    return this.menuService.selectedOption.group === 'product'
      ? this._notifications.filter(x => x.ProductId === this.menuService.selectedProduct.ProductId)
      : this._notifications;
  }
}
